package com.nonopn.skywatcher.common.app.pages.map.view.alerts

import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.alert_title_ash
import com.nonopn.skywatcher.common.app.res.alert_title_drizzle
import com.nonopn.skywatcher.common.app.res.alert_title_dust
import com.nonopn.skywatcher.common.app.res.alert_title_fog
import com.nonopn.skywatcher.common.app.res.alert_title_haze
import com.nonopn.skywatcher.common.app.res.alert_title_mist
import com.nonopn.skywatcher.common.app.res.alert_title_rain
import com.nonopn.skywatcher.common.app.res.alert_title_sandstorm
import com.nonopn.skywatcher.common.app.res.alert_title_smoke
import com.nonopn.skywatcher.common.app.res.alert_title_snow
import com.nonopn.skywatcher.common.app.res.alert_title_squall
import com.nonopn.skywatcher.common.app.res.alert_title_thunderstorm
import com.nonopn.skywatcher.common.app.res.alert_title_tornado
import com.nonopn.skywatcher.common.app.res.weather_ash
import com.nonopn.skywatcher.common.app.res.weather_drizzle
import com.nonopn.skywatcher.common.app.res.weather_dust
import com.nonopn.skywatcher.common.app.res.weather_fog
import com.nonopn.skywatcher.common.app.res.weather_haze
import com.nonopn.skywatcher.common.app.res.weather_lightning
import com.nonopn.skywatcher.common.app.res.weather_mist
import com.nonopn.skywatcher.common.app.res.weather_rainy
import com.nonopn.skywatcher.common.app.res.weather_sandstorm
import com.nonopn.skywatcher.common.app.res.weather_smoke
import com.nonopn.skywatcher.common.app.res.weather_snowy
import com.nonopn.skywatcher.common.app.res.weather_squall
import com.nonopn.skywatcher.common.app.res.weather_tornado
import eu.codlab.weather.common.models.WeatherConditionAlertType as Type

val Alerts = listOf(
    Triple(Type.Thunderstorm, Res.string.alert_title_thunderstorm, Res.drawable.weather_lightning),
    Triple(Type.Drizzle, Res.string.alert_title_drizzle, Res.drawable.weather_drizzle),
    Triple(Type.Rain, Res.string.alert_title_rain, Res.drawable.weather_rainy),
    Triple(Type.Snow, Res.string.alert_title_snow, Res.drawable.weather_snowy),
    Triple(Type.Mist, Res.string.alert_title_mist, Res.drawable.weather_mist),
    Triple(Type.Smoke, Res.string.alert_title_smoke, Res.drawable.weather_smoke),
    Triple(Type.Haze, Res.string.alert_title_haze, Res.drawable.weather_haze),
    Triple(Type.Sandstorm, Res.string.alert_title_sandstorm, Res.drawable.weather_sandstorm),
    Triple(Type.Fog, Res.string.alert_title_fog, Res.drawable.weather_fog),
    Triple(Type.Dust, Res.string.alert_title_dust, Res.drawable.weather_dust),
    Triple(Type.Ash, Res.string.alert_title_ash, Res.drawable.weather_ash),
    Triple(Type.Squall, Res.string.alert_title_squall, Res.drawable.weather_squall),
    Triple(Type.Tornado, Res.string.alert_title_tornado, Res.drawable.weather_tornado),
)
